export const $HeaderModuleName = "header";

export type THeaderState = {
    flyoutActive: boolean;
    sidebarActive: boolean;
    mobile: boolean;
};
